import { render, staticRenderFns } from "./ReturnSend.vue?vue&type=template&id=e192105a&scoped=true"
import script from "./ReturnSend.vue?vue&type=script&lang=js"
export * from "./ReturnSend.vue?vue&type=script&lang=js"
import style0 from "./ReturnSend.vue?vue&type=style&index=0&id=e192105a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e192105a",
  null
  
)

export default component.exports